import React from 'react'
import PropTypes from 'prop-types'
import { isLoaded, isEmpty } from 'react-redux-firebase'

// Todo: Change selected from only id to {} so profile can get project info
const SelectProject = ({ projects, selectProjectOnChange, selectedProject }) => {
  if(isEmpty(projects) && isLoaded(projects)) return (<div>You have no projects yet</div>)
  
  const projectList = !isLoaded(projects)
      ? ''
      : Object.keys(projects).map((key) => {
          return (
            <option key={key} value={key}>
              {projects[key].name}
            </option>
          )
        })
  return (
      <select value={selectedProject} onBlur={selectProjectOnChange}>
        <option value=''>Select Project</option>
        {projectList}
      </select>
  )
}

SelectProject.propTypes = {
  projects: PropTypes.objectOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      rate: PropTypes.string.isRequired
    }).isRequired
  ),
  selectProjectOnChange: PropTypes.func,
  selectedProject: PropTypes.string
}

export default SelectProject



// WEBPACK FOOTER //
// ./src/components/SelectProject/SelectProject.js